enum TemplateEvents {
    // テンプレート追加・更新
    UpdateTemplateStarted = "[TemplateEvents] UpdateTemplateStarted",
    UpdateTemplateComplete = "[TemplateEvents] UpdateTemplateComplete",

    // テンプレート削除
    DeleteTemplateStarted = "[TemplateEvents] DeleteTemplateStarted",
    DeleteTemplateComplete = "[TemplateEvents] DeleteTemplateComplete",
    DeleteTemplateFailed = "[TemplateEvents] DeleteTemplateFailed",
    ResetDeleteTemplateError = "[TemplateEvents] ResetDeleteTemplateError",

    // テンプレート名変更
    RenameTemplateStarted = "[TemplateEvents] RenameTemplateStarted",
    RenameTemplateComplete = "[TemplateEvents] RenameTemplateComplete",

    // テンプレート一覧取得
    GetTemplatesStarted = "[TemplateEvents] GetTemplatesStarted",
    GetTemplatesComplete = "[TemplateEvents] GetTemplatesComplete",
}

export default TemplateEvents;
